<template>
    <main class="mt-2">
        <div>
            <div class="alert alert-info border text-center small text-bold mx-3">
                <i class="fas fa-info-circle mr-1"></i> Diligenciar entre las semanas 28 y 32 de gestación.
            </div>
        </div>
        <div class="card mb-2 shadow-none " 
             v-for="(item, index) in $v.formulario.$each.$iter" :key="item.id">
            
            <div class="card-header bg-transparent border-0 pb-0 pt-1 mt-2">
                <div class="d-flex align-items-center border-bottom pb-2">
                    <i :class="[getIcon(item.$model.nombre), getTextColor(item.$model.nombre)]" class="mr-2 opacity-75"></i>
                    <h6 class="m-0 font-weight-bold text-uppercase small tracking-wide" :class="getTextColor(item.$model.nombre)">
                        {{ item.$model.nombre }}
                    </h6>
                </div>
            </div>

            <div class="card-body pt-2">
                <div class="row">
                        <div v-show="pregunta.visible"
                            class="col-xl-6 col-lg-4 col-md-6 mb-1" 
                            v-for="(pregunta, pIndex) in item.$model.preguntas" 
                            :key="`pregunta_${pIndex}`"
                        >
                            <div v-show="pregunta.visible">
                                <buttonsCheck
                                    :antecedente="pregunta"
                                    :label="pregunta.nombre"
                                    :type="pregunta.tipo"
                                    :validator="$v.formulario.$each[index].preguntas.$each[pIndex].respuesta"
                                    v-model="pregunta.respuesta"
                                    @input="onPreguntaChange(item.$model, pregunta)"
                                >
                                </buttonsCheck>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="alert alert-danger-soft border text-center small text-bold mx-3" v-if="$v.formulario.$error && $v.formulario.$dirty">
            <i class="fas fa-info-circle mr-1"></i> Por favor complete los campos obligatorios para continuar.
        </div>

        <div class="d-flex justify-content-end mx-2">
            <button class="btn btn-success btn-sm" @click="guardarPlan"><i class="fas fa-save"></i> Guardar</button>
        </div>
    </main>
</template>

<script>
import formulariosService from "../../../services/formulariosService";
import Toast from '../../../components/common/utilities/toast';
import respuestasFormulariosService from '../../../services/respuestasFormulariosService';
import { isEmpty } from "lodash";
import buttonsCheck from '../base/baseButtonsCkeck/indexButtonsNoOptions';

// Nombres de preguntas que dependen del acompañamiento
const PREGUNTAS_PAREJA = ['Nombre del acompañante (pareja/familiar)', 'Teléfono del acompañante (pareja/familiar)'];
const PREGUNTAS_DOULA  = ['Nombre de partera o doula', 'Teléfono de partera o doula'];

// Nombre de la pregunta padre del tipo de parto
const PREGUNTA_TIPO_PARTO = '¿Qué tipo de parto planea?';
const PREGUNTA_FECHA_PARTO = 'Fecha probable de parto / Fecha programada de cesárea';

export default {
    props: ['idHistoria', 'finalizada', 'codigo', 'trimestre', 'idEmbarazo'],
    components: { buttonsCheck },
    data() {
        return {
            formulario: {},
            id_formulario: '',
        }
    },
    validations() {
        return {
            formulario: {
                $each: {
                    preguntas: {
                        $each: {
                            respuesta: {
                                required(value, pregunta) {
                                    // Si la pregunta no es visible, no se valida
                                    if (!pregunta.visible) return true;
                                    return !!value;
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    methods: {

        // -----------------------------------------------
        // Visibilidad inicial de todas las preguntas
        // -----------------------------------------------
        calcularVisibilidad(secciones) {
            secciones.forEach(seccion => {

                // --- Acompañamiento ---
                if (seccion.nombre === 'Acompañamiento') {
                    const padre = seccion.preguntas.find(p => p.nombre.includes('¿Quién te acompañará'));
                    if (padre) {
                        this.aplicarVisibilidadAcompanamiento(seccion.preguntas, padre.respuesta);
                    }
                }

                // --- Tipo de parto / Fecha ---
                if (seccion.nombre === 'Antecedentes') {
                    const padre = seccion.preguntas.find(p => p.nombre === PREGUNTA_TIPO_PARTO);
                    if (padre) {
                        this.aplicarVisibilidadFecha(seccion.preguntas, padre.respuesta);
                    }
                }
            });
        },

        // -----------------------------------------------
        // Muestra/oculta campos de acompañamiento
        // -----------------------------------------------
        aplicarVisibilidadAcompanamiento(preguntas, valor) {
            preguntas.forEach(p => {
                if (PREGUNTAS_PAREJA.includes(p.nombre)) {
                    p.visible = ['PAREJA', 'AMBAS'].includes(valor);
                } else if (PREGUNTAS_DOULA.includes(p.nombre)) {
                    p.visible = ['DOULA', 'AMBAS'].includes(valor);
                }
            });
        },

        // -----------------------------------------------
        // Muestra/oculta campo de fecha según tipo de parto
        // -----------------------------------------------
        aplicarVisibilidadFecha(preguntas, valor) {
            preguntas.forEach(p => {
                if (p.nombre === PREGUNTA_FECHA_PARTO) {
                    p.visible = ['VAGINAL', 'CESAREA'].includes(valor);
                }
            });
        },

        // -----------------------------------------------
        // Se ejecuta cada vez que cambia una respuesta
        // -----------------------------------------------
        onPreguntaChange(seccion, preguntaCambiada) {

            if (seccion.nombre === 'Acompañamiento' && preguntaCambiada.nombre.includes('¿Quién te acompañará')) {
                this.aplicarVisibilidadAcompanamiento(seccion.preguntas, preguntaCambiada.respuesta);

                // Limpiar respuestas de campos que se ocultaron
                seccion.preguntas.forEach(p => {
                    if (!p.visible) p.respuesta = '';
                });
            }

            if (seccion.nombre === 'Antecedentes' && preguntaCambiada.nombre === PREGUNTA_TIPO_PARTO) {
                this.aplicarVisibilidadFecha(seccion.preguntas, preguntaCambiada.respuesta);

                seccion.preguntas.forEach(p => {
                    if (p.nombre === PREGUNTA_FECHA_PARTO && !p.visible) p.respuesta = '';
                });
            }
        },

        // -----------------------------------------------
        // Carga el formulario y respuestas previas
        // -----------------------------------------------
        async cargarFormulario() {
            try {
                this.LoaderSpinnerShow();

                const response = await formulariosService.showByCode(this.codigo);
                this.id_formulario = response.data.id;

                const respuestas_formulario = await respuestasFormulariosService.showByRespuestableEmbarazo({
                    id: this.idEmbarazo,
                    id_formulario: this.id_formulario,
                    trimestre: this.trimestre !== '' ? this.trimestre : '',
                });

                const tipoMap = {
                    'TEXTO': 'TEXT',
                    'OPCIONES': 'OPC',
                    'FECHA': 'DATE',
                    'NUMERO': 'NUM'
                };

                const secciones = response.data.secciones.map(x => {
                    return {
                        id: x.id,
                        nombre: x.nombre,
                        preguntas: x.preguntas.map(y => {
                            let respuesta = '';
                            if (!isEmpty(respuestas_formulario.data)) {
                                respuesta = respuestas_formulario.data.items.find(r => r.id_pregunta === y.id)?.valor || '';
                            }
                            return {
                                id: y.id,
                                id_seccion: y.id_seccion,
                                nombre: y.nombre,
                                opciones: y.opciones,
                                tipo: tipoMap[y.tipo] || '',
                                respuesta: respuesta,
                                visible: true, // todas visibles por defecto, calcularVisibilidad las ajusta
                            }
                        })
                    }
                });

                // Aplicar visibilidad según respuestas cargadas (modo edición)
                this.calcularVisibilidad(secciones);

                this.formulario = secciones;

                this.LoaderSpinnerHide();

            } catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrió un error al procesar la solicitud'
                });
            }
        },

        // -----------------------------------------------
        // Guarda las respuestas
        // -----------------------------------------------
        async guardarPlan() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) return;

                let respuestas = [];

                this.formulario.forEach(x => {
                    const respuestas_secciones = x.preguntas
                        .filter(y => y.visible) // omitir preguntas ocultas
                        .map(y => {
                            const opcion = y.opciones.find(opc => opc.texto === y.respuesta);
                            return {
                                id_pregunta: y.id,
                                respuesta: y.respuesta,
                                id_opcion: opcion !== undefined ? opcion.id : '',
                            }
                        });

                    respuestas.push(...respuestas_secciones);
                });

                const respuestas_historia = {
                    id_embarazo: this.idEmbarazo,
                    id_formulario: this.id_formulario,
                    respuestas: respuestas,
                    trimestre: this.trimestre
                }

                this.LoaderSpinnerShow();
                await respuestasFormulariosService.storeFormularioEmbarazo(respuestas_historia);
                this.LoaderSpinnerHide();

                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });

            } catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrió un error al procesar la solicitud'
                });
            }
        },

        // --- Helpers de UI ---
        getIcon(nombre) {
            const icons = {
                'Antecedentes': 'fas fa-history',
                'Acompañamiento': 'fas fa-users',
                'Ambiente y Preferencias': 'fas fa-leaf',
                'Manejo del Dolor': 'fas fa-hand-holding-heart',
                'Procedimientos': 'fas fa-notes-medical',
                'Atención del Recién Nacido': 'fas fa-baby'
            };
            return icons[nombre] || 'fas fa-clipboard-check';
        },
        getBorderColor(nombre) {
            const colors = {
                'Antecedentes': 'border-left-primary',
                'Acompañamiento': 'border-left-info',
                'Atención del Recién Nacido': 'border-left-success'
            };
            return colors[nombre] || 'border-left-secondary';
        },
        getIconBg(nombre) {
            const bgs = {
                'Antecedentes': 'bg-primary-soft text-primary',
                'Acompañamiento': 'bg-info-soft text-info',
                'Atención del Recién Nacido': 'bg-success-soft text-success'
            };
            return bgs[nombre] || 'bg-gray-200 text-gray-600';
        },
        getTextColor(nombre) {
            const colors = {
                'Antecedentes': 'text-primary',
                'Acompañamiento': 'text-info',
                'Atención del Recién Nacido': 'text-success'
            };
            return colors[nombre] || 'text-gray-700';
        }
    },

    async created() {
        await this.cargarFormulario();
    },

    watch: {
        trimestre: async function (value) {
            if (value) {
                await this.cargarFormulario();
            }
        }
    },
}
</script>

<style scoped>
.tracking-wide {
    letter-spacing: 0.05em;
}

.opacity-75 {
    opacity: 0.75;
}

:deep(.form-control-sm) {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
}

.py-1 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
</style>